import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

export default function FAQPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(0);

  const whatsappMessage = encodeURIComponent('Merhaba, izmirvizedanismanlik.net web siteniz üzerinden yazıyorum.');
  const whatsappUrl = `https://wa.me/905422671171?text=${whatsappMessage}`;

  const faqs = [
    {
      category: 'Genel Sorular',
      questions: [
        {
          question: 'Vize danışmanları ne kadar ücret alıyor?',
          answer: 'Ücretler vize türüne ve hizmet kapsamına göre değişir. Ortalama danışmanlık bedeli başvuru türüne göre belirlenir. Detaylı fiyat bilgisi için bizimle iletişime geçebilirsiniz.',
        },
        {
          question: 'En kolay vize nereden alınır?',
          answer: 'Kişisel profil ve seyahat geçmişine göre değişmekle birlikte, Schengen ülkeleri arasında farklı değerlendirme kriterleri bulunmaktadır. Profilinize en uygun ülkeyi birlikte belirleyebiliriz.',
        },
        {
          question: 'Vize için hesapta kaç TL olması lazım?',
          answer: 'Genellikle seyahat süresine bağlı olarak günlük minimum bakiye talep edilir. Ülkeye göre değişiklik gösterebilir. Detaylı bilgi için danışmanlık hizmeti almanızı öneririz.',
        },
        {
          question: 'Vize reddi alırsam tekrar başvurabilir miyim?',
          answer: 'Evet. Ret nedenleri analiz edilerek yeniden başvuru yapılabilir. Profesyonel destek ile ret nedenlerini ortadan kaldırarak başarı şansınızı artırabilirsiniz.',
        },
      ],
    },
    {
      category: 'Schengen Vizesi',
      questions: [
        {
          question: 'Schengen vizesi ile hangi ülkelere gidebilirim?',
          answer: 'Schengen vizesi ile 27 Avrupa ülkesine seyahat edebilirsiniz: Almanya, Avusturya, Belçika, Çekya, Danimarka, Estonya, Finlandiya, Fransa, Hollanda, İspanya, İsveç, İtalya, İzlanda, Letonya, Litvanya, Lüksemburg, Macaristan, Malta, Norveç, Polonya, Portekiz, Slovakya, Slovenya, İsviçre, Yunanistan, Hırvatistan ve Lihtenştayn. İzmir Schengen vizesi başvurunuz için bizimle iletişime geçin.',
        },
        {
          question: 'Schengen vizesi ne kadar süreliğine geçerlidir?',
          answer: 'Schengen C tipi turist vizesi genellikle 90 güne kadar kısa süreli seyahat için verilir. Vize 180 gün içinde maksimum 90 gün kalmanıza izin verir. Bazı durumlarda çoklu giriş vizesi alabilir ve vize geçerlilik süresi içinde birden fazla seyahat yapabilirsiniz. İzmir vize danışmanlık hizmetimizle en uygun vize tipini belirleyebilirsiniz.',
        },
        {
          question: 'Schengen vizesi ücreti ne kadardır?',
          answer: '2026 yılı için Schengen vizesi başvuru ücreti 90 Euro\'dur. 6-12 yaş arası çocuklar için 45 Euro ücret alınır. 6 yaşından küçük çocuklar için vize ücreti yoktur. Danışmanlık hizmet ücretlerimiz için lütfen bizimle iletişime geçin. Konak vize danışmanlık ofisimizden detaylı bilgi alabilirsiniz.',
        },
      ],
    },
    {
      category: 'Amerika Vizesi',
      questions: [
        {
          question: 'Amerika vizesi mülakat soruları nelerdir?',
          answer: 'Mülakatta genellikle seyahat amacınız, mesleğiniz, gelir durumunuz, Amerika\'da kalacağınız süre, daha önce yurt dışına çıkıp çıkmadığınız, Türkiye\'ye dönüş bağlarınız gibi sorular sorulur. Mülakat İngilizce yapılır ancak tercüman talep edebilirsiniz. İzmir Amerika vizesi başvurularında mülakat hazırlığı konusunda detaylı destek sağlıyoruz.',
        },
        {
          question: 'Amerika vizesi ücreti ne kadardır?',
          answer: '2026 yılı için Amerika B1/B2 turist vizesi başvuru ücreti 185 USD\'dir. Bu ücret iade edilmez ve vize alıp almadığınızdan bağımsızdır. Ödeme kredi kartı ile yapılabilir. İzmir Amerika vizesi danışmanlık hizmet ücretlerimiz için ofisimizi arayabilirsiniz.',
        },
        {
          question: 'Amerika vizesi ne kadar sürede çıkar?',
          answer: 'Mülakat sonrası vize işleme süresi genellikle 3-5 iş günüdür. Ancak bazı durumlarda ek inceleme (administrative processing) gerekebilir ve bu süreç 2-8 hafta sürebilir. Mülakat randevusu almak için de 2-4 hafta bekleme süresi olabilir. İzmir vize başvurusu sürecinizi hızlandırmak için erken başvuru yapmanızı öneririz.',
        },
      ],
    },
    {
      category: 'İngiltere Vizesi',
      questions: [
        {
          question: 'İngiltere vizesi için hangi belgeler gereklidir?',
          answer: 'Pasaport, fotoğraf, banka hesap özeti (son 6 ay), işyeri belgesi, seyahat planı, konaklama rezervasyonu, seyahat sigortası, gelir belgesi ve varsa daha önce aldığınız vizeler. İngiltere vizesi için online başvuru formu doldurulur ve biyometrik randevuya gidilir. İzmir İngiltere vizesi başvurularında tüm evrakları eksiksiz hazırlıyoruz.',
        },
        {
          question: 'İngiltere vizesi ücreti ne kadardır?',
          answer: '2026 yılı için İngiltere Standard Visitor Visa ücreti 115 GBP (6 aya kadar), 2 yıllık vize için 432 GBP, 5 yıllık vize için 780 GBP ve 10 yıllık vize için 978 GBP\'dir. Biyometrik randevu için ek ücret alınmaz. İzmir vize danışmanlık hizmet ücretlerimiz için bizimle iletişime geçin.',
        },
      ],
    },
    {
      category: 'Ücretler ve Ödeme',
      questions: [
        {
          question: 'Danışmanlık ücretleriniz ne kadardır?',
          answer: 'Danışmanlık ücretlerimiz vize tipine, ülkeye ve hizmet paketine göre değişiklik göstermektedir. Ücretsiz ön değerlendirme sonrasında size özel fiyat teklifi sunuyoruz. Schengen vizesi, Amerika vizesi ve İngiltere vizesi için farklı paketlerimiz bulunmaktadır. Detaylı bilgi için +90 542 267 11 71 numaralı telefondan bizi arayabilirsiniz.',
        },
        {
          question: 'Ödeme nasıl yapılır?',
          answer: 'Ödeme nakit, kredi kartı veya banka havalesi ile yapılabilir. Taksit seçeneklerimiz mevcuttur. Konsolosluk vize ücretleri ayrıca ödenir. İzmir Konak ofisimizde güvenli ödeme yöntemleri ile hizmet veriyoruz.',
        },
      ],
    },
    {
      category: 'Randevu ve Süreç',
      questions: [
        {
          question: 'Konsolosluk randevusu nasıl alınır?',
          answer: 'Konsolosluk randevularını sizin adınıza biz alıyoruz. Uygun tarih ve saati size bildiriyoruz. Randevu öncesi gerekli tüm hazırlıkları yapıyor, evraklarınızı kontrol ediyor ve sizi randevuya hazırlıyoruz. İzmir vize başvurusu sürecinizde randevu alma konusunda endişelenmenize gerek yok.',
        },
        {
          question: 'Vize başvurusu sonrası ne olur?',
          answer: 'Başvuru sonrası vizeniz işleme alınır. Süreç boyunca durumu takip ediyor ve sizi bilgilendiriyoruz. Vize çıktığında pasaportunuzu konsolosluklardan alıp size teslim ediyoruz. İzmir vize danışmanlık hizmetimiz vize elinize ulaşana kadar devam eder.',
        },
      ],
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-primary/10 via-lightBlue to-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="font-heading font-bold text-4xl lg:text-5xl text-darkBlue mb-6">
              Sıkça Sorulan Sorular
            </h1>
            <p className="font-body text-lg text-gray-600 leading-relaxed">
              İzmir vize başvurusu, Schengen vizesi, Amerika vizesi ve İngiltere vizesi hakkında merak ettikleriniz
            </p>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {faqs.map((category, categoryIndex) => (
            <div key={categoryIndex} className="mb-12">
              <h2 className="font-heading font-bold text-2xl text-darkBlue mb-6 flex items-center">
                <span className="w-2 h-8 bg-secondary rounded-full mr-3"></span>
                {category.category}
              </h2>
              <div className="space-y-4">
                {category.questions.map((faq, faqIndex) => {
                  const globalIndex = categoryIndex * 100 + faqIndex;
                  return (
                    <div
                      key={faqIndex}
                      className="bg-white rounded-xl shadow-md overflow-hidden transition-all duration-300 border-2 border-transparent hover:border-lightBlue"
                    >
                      <button
                        onClick={() => setOpenFaq(openFaq === globalIndex ? null : globalIndex)}
                        className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 transition-colors"
                      >
                        <h4 className="font-heading font-bold text-darkBlue pr-4 flex-1">
                          {faq.question}
                        </h4>
                        <i
                          className={`text-secondary text-2xl transition-transform flex-shrink-0 ${
                            openFaq === globalIndex ? 'ri-subtract-line' : 'ri-add-line'
                          }`}
                        ></i>
                      </button>
                      {openFaq === globalIndex && (
                        <div className="px-6 pb-6 bg-lightBlue/30">
                          <p className="font-body text-gray-700 leading-relaxed">{faq.answer}</p>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-20 bg-lightBlue">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="bg-white rounded-2xl p-8 lg:p-12 shadow-lg">
            <div className="w-16 h-16 bg-secondary/10 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-question-answer-line text-secondary text-3xl"></i>
            </div>
            <h2 className="font-heading font-bold text-2xl lg:text-3xl text-darkBlue mb-4">
              Sorunuzun Cevabını Bulamadınız mı?
            </h2>
            <p className="font-body text-lg text-gray-600 mb-8">
              İzmir vize danışmanlık ekibimiz size yardımcı olmak için hazır. Ücretsiz ön değerlendirme için bizimle iletişime geçin.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="tel:+905422671171"
                className="bg-secondary hover:bg-secondary/90 text-white px-8 py-4 rounded-full font-body font-bold transition-all shadow-md hover:shadow-lg whitespace-nowrap flex items-center space-x-2"
              >
                <i className="ri-phone-line"></i>
                <span>+90 542 267 11 71</span>
              </a>
              <a
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-green-500 hover:bg-green-600 text-white px-8 py-4 rounded-full font-body font-bold transition-all shadow-md hover:shadow-lg whitespace-nowrap flex items-center space-x-2"
              >
                <i className="ri-whatsapp-line"></i>
                <span>WhatsApp</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
}
